/*Navigation*/
export const handelChangeStatusPageNavigation = (statusPage) => ({
    type: 'CHANGE_STATUS_PAGE_NAVIGATION',
    statusPage
});
